import PropTypes from "prop-types"
import DetailsSelectionHOC from "./details_selection_hoc"
import ServiceSelectorContent from "./service_selector_content"
import UsersStats from "../users/user_stats"
import EngagementStats from "../engagement/engagement_stats"
import TopPublishedApplets from "../top_published_applets/top_published_applets"
import TopServices from "../top_services"
import {
  worksWithUserMetricsQuery,
  worksWithMapper,
} from "../users/user_metrics_fetcher"
import { worksWithTopPublishedAppletsQuery } from "../top_published_applets/top_published_applets_fetcher"
import { worksWithTopPublishedAppletsMapper } from "../top_published_applets/gql_data_mapper"

const ServicesPage = props => {
  const PeriodWrapped = ({ selection, ...props }) => {
    if (selection.data.id != -1) {
      const userProps = {
        ...props,
        metrics: [
          "new_users_all_time",
          "active_users_all_time",
          "users_with_an_applet_run_daily",
        ],
        worksWithChannelModuleName: selection.data.id,
        worksWithChannelName: selection.data.name,
        query: worksWithUserMetricsQuery,
        mapper: worksWithMapper,
        subHeaderText: `Adoption metrics for users connecting %WORKS_WITH_SERVICE_NAME% to %SERVICE_NAME%`,
        headerSeparator: false,
      }

      const engagementProps = {
        ...props,
        worksWithChannelModuleName: selection.data.id,
        worksWithChannelName: selection.data.name,
        subHeaderText: `From users connecting %WORKS_WITH_SERVICE_NAME% to %SERVICE_NAME%`,
        headerSeparator: false,
      }

      const topAppletsProps = {
        ...props,
        worksWithChannelModuleName: selection.data.id,
        worksWithChannelName: selection.data.name,
        query: worksWithTopPublishedAppletsQuery,
        mapper: worksWithTopPublishedAppletsMapper,
        subHeaderText: `The top %WORKS_WITH_SERVICE_NAME% to %SERVICE_NAME% Applets`,
      }

      return (
        <div>
          <UsersStats {...userProps} />
          <EngagementStats {...engagementProps} />
          <TopPublishedApplets {...topAppletsProps} />
        </div>
      )
    } else {
      const servicesProps = {
        ...props,
        subHeaderText: `Top services connected to %SERVICE_NAME%`,
      }
      return <TopServices {...servicesProps} />
    }
  }

  const ServicesContent = item => (
    <ServiceSelectorContent
      serviceName={props.serviceName}
      contentServiceName={item.name}
      contentServiceColor={item.brand_color}
      contentServiceIcon={item.monochrome_image_url}
    />
  )

  const initialService =
    props.initialService &&
    props.items.find(i => i.module_name == props.initialService.module_name)
  const initialServiceData = initialService && {
    data: {
      id: initialService.module_name,
      name: initialService.name,
    },
  }

  const ServicesContainer = DetailsSelectionHOC({
    WrappedComponent: PeriodWrapped,
    options: [
      {
        data: {
          id: -1,
          name: "All",
        },
        ContentComponent: ServicesContent,
      },
      ...props.items.map(service => {
        return {
          data: {
            ...service,
            id: service.module_name,
          },
          ContentComponent: ServicesContent.bind(null, service),
        }
      }),
    ],
    rootUrl: "services",
    serviceTitle: props.serviceName,
    serviceColor: props.serviceColor,
    serviceImage: props.serviceImage,
    initialSelection: initialServiceData,
  })

  return <ServicesContainer {...props} />
}

ServicesPage.propTypes = {
  items: PropTypes.array,
  serviceName: PropTypes.string,
  serviceModuleName: PropTypes.string,
  serviceColor: PropTypes.string,
  serviceImage: PropTypes.string,
  initialService: PropTypes.object,
}

export default ServicesPage
